import React from "react";
import { useIntl } from "react-intl";

/*
    Filter Icon
    props:
        - title: string, override the default title 'Filter'
        - color: string, override the default color '#00549A' (bell blue)
*/

const FilterIcon = (props) => {
    const intl = useIntl();
    return (
        <svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <title>{props.title || (intl.locale == "en" ? "Filter" : "Filtre")}</title>
            <path d="M1.125 1.41675H14.875M5.70833 10.5834H10.2917M3.41667 6.00008H12.5833" stroke={props.color || "#00549A"} strokeWidth="1.5" />
        </svg>
    );
};

export default FilterIcon;
